import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider, ErrorBoundary } from './providers';
import { AppRouter } from './router';

export const App = () => (
  <ErrorBoundary>
    <BrowserRouter>
      <ThemeProvider>
        <AppRouter />
      </ThemeProvider>
    </BrowserRouter>
  </ErrorBoundary>
);
